const dateToTimestamp = (date: Date): number => date.getTime() / 1000;

export default dateToTimestamp;
